import { useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../../ReduxTool/store/hooks";
import { setProject3dAnalysisIframeURL, setSubsequentOption } from "../../../../ReduxTool/Slice/Consumer/ConsumerReducers";
import { AcceptIcon, BackBoxIcon, CheckCircleIcon, HeadsetIcon, RefreshIcon, ShieldCheckIcon } from "../../../../assests/icons/Icons";
import { memo, useEffect, useState } from "react";
import { Button } from "../../../../Components/Button";
import { setButtonLoader, setModalHeaderFooter } from "../../../../ReduxTool/Slice/CommonReducers/CommonReducers";
import { toast } from "react-toastify";
import { switchView } from "../../../../lib/Customer/SwitchMap";
import globalLayers from "../../../../Utils/CustomerMaps/Maps/GlobaLMap";
import { fetchBuildingfromCoordinates } from "../../../../Utils/Fetch3D/fetchRoof";
import { EPCRoofAnalysisURLString } from "../../../../Utils/baseUrls";
import Toast from "../../../../Components/ErrorBoundry/Toast";
import { ProjectTy } from "../../../../ReduxTool/Slice/Auth/types";
import { set3dpayment } from "../../../../ReduxTool/Slice/Payment/paymentReducer";
import { PVNXT_MODE } from "../../../../Utils/Const";
import { has3dAnalysisAccess } from "../../../../lib/payments/payu";
// import { CheckCircleIcon } from "@heroicons/react/24/outline"; // Ensure you have heroicons or use <img>/svg

const ModeRadioList = [
  { label: "pvNXT Mode", value: "pvNXT Mode" },
  { label: "Self Mode", value: "Self Mode" },
];
type ModeOptionTy = "pvNXT Mode" | "Self Mode";

const ConfirmLead = ({ onProceed, isinstallationmodechange, isLoading }: { onProceed?: (Option: ModeOptionTy) => void, isinstallationmodechange?: boolean, isLoading?: boolean }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { roofAnalysis: { selected_project } } = useAppSelector(state => state.consumerReducers);
  const { subsequentOption } = useAppSelector(state => state.consumerReducers.roofAnalysis);
  const is3ddata = useAppSelector(state => state.mapref.is3ddata);
  const { is3dpayment } = useAppSelector(state => state.payment)
  const { user } = useAppSelector(state => state.auth);

  const [analysisConfirm, setAnalysisConfirm] = useState(false);
  const [isAnalysis, setIsAnalysis] = useState(false);
  const [loadingMode, setLoadingMode] = useState<ModeOptionTy | null>(null);
  const [show, hide] = useState(false)

  useEffect(() => {
    if (!isLoading) {
      setLoadingMode(null);
    }
  }, [isLoading]);

  const handleProceed = (mode: ModeOptionTy) => {
    setLoadingMode(mode);
    onProceed?.(mode);
  };

  const fetchIframeAnalysis = async () => {
    setIsAnalysis(true)
    if (show) {
      await switchView(globalLayers.activeView)
      return
    }
    const building = await fetchBuildingfromCoordinates(selected_project?.lat as number, selected_project?.lng as number, selected_project?.graphicLayer);
    if (building) {
      const token = localStorage.getItem("token");
      const url = `${EPCRoofAnalysisURLString}/Consumer/RoofAnalysis?token=${token}&userid=${user.userid}&projectid=${(selected_project as ProjectTy)?.buildingid}`;
      dispatch(setProject3dAnalysisIframeURL(url))
    } else {
      Toast({ messageText: 'No, 3D roof availabe here', messageType: 'W', toastId: '3d-fecth', autoClose: 3500 })
    }
    setIsAnalysis(false)
    setAnalysisConfirm(false)
    return
  }


  const [checkingAccess, setCheckingAccess] = useState(false);

  const handleOpenConfirm = async () => {
    dispatch(setButtonLoader("loading3d"))
    // Always ask the server: is3dpayment is also set by an unpaid order's payment_id and isn't per project
    setCheckingAccess(true)
    const hasAccess = await has3dAnalysisAccess(selected_project?.projectid)
    setCheckingAccess(false)
    if (hasAccess) {
      dispatch(set3dpayment(true))
      fetchIframeAnalysis()
    } else {
      // Only offer payment when the 3D view can actually open: the same building lookup the view uses
      // (is3droofavailable is decided at project creation and can disagree with it)
      setCheckingAccess(true)
      const building = await fetchBuildingfromCoordinates(selected_project?.lat as number, selected_project?.lng as number, selected_project?.graphicLayer).catch(() => null)
      setCheckingAccess(false)
      if (!building) {
        dispatch(setButtonLoader(""))
        Toast({ messageText: "3D roof analysis isn't available for this roof yet.", messageType: 'W', toastId: '3d-fecth', autoClose: 5000 })
        return
      }
      // Opens the upgrade modal; "Proceed To Payment" there starts PayU checkout
      dispatch(setModalHeaderFooter({ title: "Upgrade to 3D Roof Analysis", btnTxt: "Proceed To Payment", secondaryBtnTxt: "Cancel", isheader: true }));
      setAnalysisConfirm(true)
    }
  }


  // const handleSelectMode = (mode: string) => {
  //   dispatch(setSubsequentOption(mode));
  // };

  // const onProceed = () => {
  //   if (subsequentOption) {
  //     // Logic for proceed (e.g., navigate or API call)
  //     console.log("Proceeding with:", subsequentOption);
  //   }
  // };

  return (
    <div className="px-4 pt-2 max-w-4xl mx-auto">
      <p className="text-gray-500 text-sm mb-4">Choose the option that works best for you. You can review the details before giving final approval.</p>
      <div className="flex flex-col md:flex-row gap-6">
        {/* PVNXT Full Service Card */}
        <div className={`flex-1 border rounded-2xl p-6 transition-all border-black shadow-lg`}>
          <div className="flex justify-between items-start mb-4">
            <div>
              <h3 className="text-xl font- text-gray-800">{PVNXT_MODE} Full Service</h3>
              <p className="text-sm text-gray-700">Zero-hassle solar installation</p>
            </div>
            <span className="bg-green-50 text-green-700 text-xs px-2 py-1 rounded-full border border-green-500">
              Recommended
            </span>
          </div>
          {/* <Button className="btn btn-sm-primary" name={"Choose Full Service"} onClick={()=>onProceed?.("pvNXT Mode")} /> */}
          <Button className="btn btn-sm-primary" name={"Choose Full Service"} onClick={() => handleProceed("pvNXT Mode")} isLoading={isLoading && loadingMode === "pvNXT Mode"} disabled={isLoading} />
          <p className="text-xs mt-3 text-gray-400 mb-6 border-b pb-4">
            Agreements, payments, and project progress are securely managed in one place.
          </p>

          <h4 className="font-bold text-gray-800 mb-4">What happens next:</h4>
          <ul className="space-y-3">
            <ListItem text="Our team reviews your roof in detail" />
            <ListItem text="We will initiate an RFP to obtain competitive pricing" />
            <ListItem text="You receive a final optimized proposal" />
            <ListItem text="We assign a highly rated installer at a competitive price" />
            <ListItem text="Installation is fully managed and tracked for you" />
            <ListItem text="We manage design, approvals, installation, and support for you." />
          </ul>
          <p className="mt-6 text-xs text-gray-600 ">Once you select Full Service, you cannot change your selection.</p>
        </div>

        {/* Self Mode Card */}
        {!isinstallationmodechange && <div className={`flex-1 border-2 rounded-2xl p-6 transition-all border-gray-200 `}>
          <div className="mb-4">
            <h3 className="text-xl text-gray-800">Self Mode <span className="text-sm font-normal text-gray-700">(Connect with EPC)</span></h3>
            <p className="text-sm text-gray-700">Work directly with an EPC and manage the process yourself.</p>
          </div>
          {/* <Button className="btn btn-sm-outlineprimary" name={"Proceed with Self Mode"} onClick={()=>onProceed?.("Self Mode")} /> */}
          <Button className="btn btn-sm-outlineprimary" name={"Proceed with Self Mode"} onClick={() => handleProceed("Self Mode")} isLoading={isLoading && loadingMode === "Self Mode"} disabled={isLoading} />
          <p className="text-xs mt-3 text-gray-400 mb-6 border-b pb-4">
            Execution and payments will be handled outside the platform.
          </p>

          <h4 className="font-bold text-gray-800 mb-4">What happens next:</h4>
          <ul className="space-y-3">
            <ListItem text="Your request is shared with subscribed installers" />
            <ListItem text="Choose quality, evaluate ability, and proceed with confidence" />
            <ListItem text="Installers contact you with proposals" />
            <ListItem text="You compare, choose, and proceed directly" />
          </ul>
          <p className="mt-6 text-xs text-gray-600">You can change your Self Mode selection until the agreement is signed.</p>
        </div>}
      </div>

      <div className="flex items-center mt-3 gap-2">
        {!isinstallationmodechange && (<><p className="para-md text-red-500 whitespace-nowrap">
          <strong>Disclaimer:</strong> Shadow calculations are available only with an active 3D subscription.
        </p>

          {selected_project?.is3droofavailable && (<span className="get3dlink">
            <Button className="btn-md-link" name={"Get 3D Analysis"} RightIcon={<BackBoxIcon rotate90 />}
              onClick={() => handleOpenConfirm()} isLoading={checkingAccess} disabled={false} />
          </span>
          )}
        </>
        )
        } </div>

      {/* Bottom Footer Info */}
      {/* <div className="flex justify-center gap-8 mt-3 text-gray-700 text-sm">
         <span className="flex items-center gap-1"><ShieldCheckIcon /> 30-day money-back guarantee</span>
         <span className="flex items-center gap-1"><HeadsetIcon /> 24/7 support</span>
         <span className="flex items-center gap-1"><RefreshIcon /> Cancel anytime</span>
      </div> */}

      {/* <div className="flex justify-end mt-8">
        <button 
          onClick={onProceed}
          disabled={!subsequentOption}
          className={`px-10 py-2 rounded font-semibold text-white ${!subsequentOption ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#003d4d]'}`}
        >
          Proceed
        </button>
      </div> */}
    </div>
  );
};

// Helper component for list items
const ListItem = ({ text }: { text: string }) => (
  <li className="flex items-start gap-2 text-sm text-gray-700">
    <CheckCircleIcon />
    <span>{text}</span>
  </li>
);

export default memo(ConfirmLead);
